import React from "react";
import Moment from "react-moment";

const FormattedTime = ({ children }) => (
  <Moment date={children} format="h:mm a Z" />
);

export default FormattedTime;
